document.addEventListener('DOMContentLoaded', function() {
  const consultationType = document.getElementById('ConsultationType');
  const sessionType = document.getElementById('SessionType');
  const priceWrapper = document.getElementById('PriceWrapper');
  const priceDisplay = document.getElementById('PriceDisplay');
  const priceInput = document.getElementById('PriceInput');

  const prices = {
    virtual: { half: '£300–£450', full: '£500–£800' },
    direction: { half: '£800–£1,000', full: '£1,200–£1,500+' }
  };

  function updatePrice() {
    const type = consultationType.value;
    const session = sessionType.value;

    if (type && session) {
      let priceText = '';
      if (type === 'Virtual Consultation') {
        priceText = prices.virtual[session === 'Half Day' ? 'half' : 'full'];
      } else if (type === 'Creative Direction') {
        priceText = prices.direction[session === 'Half Day' ? 'half' : 'full'];
      }
      priceDisplay.textContent = priceText;
      priceInput.value = priceText;
      priceWrapper.style.display = 'block';
    } else {
      priceWrapper.style.display = 'none';
      priceDisplay.textContent = '';
      priceInput.value = '';
    }
  }

  consultationType.addEventListener('change', updatePrice);
  sessionType.addEventListener('change', updatePrice);
});



const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

function ph(input, text) {
  if (!isMobile) return;  

  let span = document.createElement("span");
  span.textContent = text;
  span.style.cssText =
    "position:absolute;left:12px;top:12px;color:#999;pointer-events:none;font-size:14px;";

  let parent = input.parentElement;
  parent.style.position = "relative";
  parent.appendChild(span);

  function toggle() {
    span.style.display = input.value ? "none" : "block";
  }

  input.addEventListener("input", toggle);
  input.addEventListener("change", toggle);
  toggle();
}

ph(document.getElementById("ContactForm-date"), "dd-mm-yyyy");
ph(document.getElementById("ContactForm-time"), "--:--");


